import Vue from "vue";
import { MutationTree } from "vuex";
import {
  IFlowState,
  IFlowSchedule,
  IFlowSchedules,
  FlowStep,
} from "@/store/modules/flow/types";

type FlowMutationsTree = MutationTree<IFlowState>;

export const mutations: FlowMutationsTree = {
  setSchedules(state: IFlowState, payload: IFlowSchedules) {
    state.schedules = payload;
  },

  setDone(state: IFlowState, payload: boolean) {
    if (payload) {
      state.step = FlowStep.Done;
    }
  },

  setEtl(state: IFlowState, payload: boolean) {
    state.etl = payload;
  },

  setWait(state: IFlowState, payload: number) {
    state.wait = payload;
  },

  setPrevious(state: IFlowState, payload: { step: FlowStep; subject: string }) {
    state.step = payload.step;
    state.subject = payload.subject;
  },

  setSection(state: IFlowState, payload: Partial<IFlowState>) {
    const { wait, subject, step } = payload;

    state.etl = !!payload.etl;
    state.subject = subject || null;
    state.wait = wait || 0;
    state.step = step || null;
    state.goto = payload.goto;
  },

  setTakeSection(state: IFlowState, payload: Partial<IFlowState>) {
    const { etl } = state;

    state.etl = etl === undefined || etl === null ? null : etl;
    state.wait = payload.wait || 0;
    state.step = payload.step || null;
  },

  finishSection(
    state: IFlowState,
    payload: { schedule: IFlowSchedule; step: FlowStep; subject: string }
  ) {
    if (state.schedules) {
      Vue.set(state.schedules, payload.subject, payload.schedule);
      state.step = payload.step;
    }
  },

  finishFlow(state: IFlowState) {
    state.schedules = null;
    state.subject = null;
    state.wait = null;
    state.step = null;
    state.etl = null;
  },
};
